<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              @if (reference$ | async; as reference) {
                <div class="marginTop">
                  <div class="row">
                    <div
                      class="col-md-6 marginTop"
                      [ngClass]="{ 'w-100': owners.length > 1 }"
                    >
                      <pr-input-column
                        label="Intitulé de la profession (ou dernière profession si retraité)"
                        [derrors]="derrors"
                      >
                        <input
                          (input)="onLabelChange($event.target.value, index)"
                          formControlName="professionLabel"
                          type="text"
                        />
                      </pr-input-column>
                      @if (note && index == noteIndex) {
                        <info [option]="{ icon: 'info' }"
                          >En raisons des lois sur les données numérique, nous
                          sommes dans l’obligation d’offusquer cette
                          information.
                        </info>
                      }
                    </div>
                    <div
                      class="col-md-6 marginTop"
                      [ngClass]="{ 'w-100': owners.length > 1 }"
                    >
                      <pr-input-column label="Situation" [derrors]="derrors">
                        <mat-select
                          formControlName="professionSituation"
                          (valueChange)="updateSituation($event, index)"
                        >
                          @for (situation of situations; track situation) {
                            <mat-option [value]="situation.id">
                              {{ situation.value }}
                            </mat-option>
                          }
                        </mat-select>
                      </pr-input-column>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="marginTop"
                      [ngClass]="{
                        'w-100': owners.length > 1,
                        'col-md-12': showSwisslifeActivitySectorLcbFt,
                        'col-md-6': !showSwisslifeActivitySectorLcbFt,
                      }"
                    >
                      <pr-input-column label="Statut" [derrors]="derrors">
                        <mat-select
                          formControlName="professionGroup"
                          (valueChange)="updateGroupe($event, index)"
                        >
                          @for (group of groupes[index]; track group) {
                            <mat-option [value]="group.groupe">
                              {{ group.label }}
                            </mat-option>
                          }
                        </mat-select>
                      </pr-input-column>
                    </div>
                    @if (!showSwisslifeActivitySectorLcbFt) {
                      <div
                        class="col-md-6 marginTop"
                        [ngClass]="{ 'w-100': owners.length > 1 }"
                      >
                        <pr-input-column
                          label="Secteur d'activité"
                          [derrors]="derrors"
                        >
                          <mat-select
                            formControlName="professionActivitySector"
                          >
                            @for (
                              companyActivitySector of companyActivitySectors;
                              track companyActivitySector
                            ) {
                              <mat-option [value]="companyActivitySector.id">
                                {{ companyActivitySector.value }}
                              </mat-option>
                            }
                          </mat-select>
                        </pr-input-column>
                      </div>
                    }
                  </div>
                  <div class="row">
                    <div
                      class="col-md-6 marginTop"
                      [ngClass]="{ 'w-100': owners.length > 1 }"
                    >
                      <pr-input-column
                        label="CSP correspondante à votre profession"
                        [derrors]="derrors"
                      >
                        <mat-select
                          formControlName="professionCategory"
                          (valueChange)="updateCategorie($event, index)"
                        >
                          @for (
                            categorie of categories[index];
                            track categorie
                          ) {
                            <mat-option
                              [matTooltip]="categorie.label"
                              matTooltipPosition="right"
                              [value]="categorie.categorie"
                            >
                              {{ categorie.label }}
                            </mat-option>
                          }
                        </mat-select>
                      </pr-input-column>
                    </div>
                    <div
                      class="col-md-6 marginTop"
                      [ngClass]="{ 'w-100': owners.length > 1 }"
                    >
                      <div style="width: calc(100% - 27px)">
                        <pr-input-date
                          label="Date de prise de fonction"
                          formControlName="professionStartDate"
                          [derrors]="derrors"
                          [isDefault]="false"
                        ></pr-input-date>
                      </div>
                    </div>
                  </div>
                  @if (showingWorkInPublic(form, index)) {
                    <div class="row">
                      <div class="col col-md-12">
                        <pr-input-radio
                          formControlName="professionWorkInPublic"
                          columns="3"
                          [toggle]="true"
                          [isDefault]="false"
                          label="Travail dans le secteur public"
                        >
                        </pr-input-radio>
                      </div>
                    </div>
                  }
                  @if (showSwisslifeActivitySectorLcbFt) {
                    <div class="row">
                      <hr />
                      <p>Questions supplémentaire Swisslife</p>
                      <div
                        class="col-md-6"
                        [ngClass]="{ 'w-100': owners.length > 1 }"
                      >
                        <pr-input-column
                          label="Secteur d'activité LCB-FT"
                          [derrors]="derrors"
                        >
                          <mat-select
                            formControlName="swisslifeActivitySectorLcbFt"
                          >
                            @for (
                              sector of swisslifeActivitySectors;
                              track sector
                            ) {
                              <mat-option [value]="sector.id">
                                {{ sector.value }}
                              </mat-option>
                            }
                          </mat-select>
                        </pr-input-column>
                      </div>
                      @if (
                        owner.get('swisslifeActivitySectorLcbFt').value ===
                        'AUTRE'
                      ) {
                        <div
                          class="col-md-6"
                          [ngClass]="{ 'w-100': owners.length > 1 }"
                        >
                          <pr-input-column
                            label="Détail sur le secteur d'activité"
                            [derrors]="derrors"
                          >
                            <pr-select-search
                              formControlName="swisslifeActivitySectorLcbFtOther"
                              label="Détail sur le secteur d'activité"
                              [options]="inseeActivitySectors"
                            >
                            </pr-select-search>
                          </pr-input-column>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
